import { type AuthControlsOptions, renderAuthControls } from '@bomdisoft/auth-bff/native';
import { CREDIT_CARD_ROUNDED_GLYPH, renderBrand, renderIcon, renderTopBar, type TopBarSecondaryLink } from '@bomdisoft/components/native';
import { account, billing, getLanguageFromLocale, login, logout, signUp } from '@bomdisoft/translations';
import { getSharedBillingUrl } from '@bomdisoft/utilities';
import { toLogoUrl } from '@pieleaf/frame/images';
import { homeText, legalEyebrow, orderProduceText } from '@pieleaf/translations';

export const LEGAL_PATH_SUFFIXES = ['/privacy-policy', '/terms-of-service', '/security', '/gdpr', '/cookie-policy', '/data-deletion'];

export const isLegalPath = (pathname: string) => LEGAL_PATH_SUFFIXES.some(suffix => pathname.endsWith(suffix) || pathname.includes(`${suffix}/`));

export const toTopBarAuthOptions = (lang: string): AuthControlsOptions => {
  const language = getLanguageFromLocale(lang);
  return {
    accountHref: `/${lang}/account`,
    items: [{ external: true, href: getSharedBillingUrl(), icon: renderIcon(CREDIT_CARD_ROUNDED_GLYPH), label: billing[language], testId: 'top-bar-billing' }],
    manageAccountLabel: account[language],
    menuLabel: account[language],
    signInLabel: login[language],
    signOutLabel: logout[language],
    signUpLabel: signUp[language],
  };
};

export const renderPieleafTopBar = ({ lang, pathname }: { lang: string; pathname: string }) => {
  const language = getLanguageFromLocale(lang);
  const secondaryLink: TopBarSecondaryLink = isLegalPath(pathname) ? { href: `/${lang}`, label: homeText[language], testId: 'top-bar-legal' } : { href: `/${lang}/privacy-policy`, label: legalEyebrow[language], testId: 'top-bar-legal' };
  return renderTopBar({
    authSlot: renderAuthControls(toTopBarAuthOptions(lang), { status: 'loading' }),
    brand: renderBrand({ href: `/${lang}`, logoHeight: 28, logoSrc: toLogoUrl('/images/logo.png', 28), logoWidth: 28, priority: true, size: 20, testId: 'top-bar-brand', wordmarkSuffix: 'ieleaf' }),
    ctaHref: `/${lang}/orders`,
    ctaLabel: orderProduceText[language],
    maxWidth: 1200,
    secondaryLink,
  });
};
